import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { BREAKPOINTS } from '@root/app.config';
import { BlindData, GalleryViewType, GalleryViewTypes, QuotationPrice } from '@root/app.interfaces';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Image } from '@features/summary-blind-gallery/components/blind-images/blind-images.component';

@Component({
	selector: 'app-blind-information',
	templateUrl: './blind-information.component.html',
	styleUrls: ['./blind-information.component.scss', './blind-information.responsive.scss'],
})
export class BlindInformationComponent implements OnChanges {
	@Input() blind: BlindData;
	@Input() index: number;
	@Input() priceItem: QuotationPrice;
	@Input() viewType: GalleryViewType = GalleryViewTypes.Default;
	@Input() labelBreakpoint: string = BREAKPOINTS['phone'].max;

	@HostBinding('class') get hostClass() {
		return this.viewType;
	}

	protected readonly GalleryViewTypes = GalleryViewTypes;
	protected readonly BREAKPOINTS = BREAKPOINTS;

	protected mainImage: Image;
	protected hasOperationOptionalExtraFee: boolean;

	ngOnChanges() {
		this.getMainImage();
		this.getOperationExtraFeeOptional();
	}

	getMainImage(): void {
		this.mainImage = { name: 'main', type: 'full', url: this.blind.blind_img_url, loading: true };
	}

	onPopover(popover: NgbPopover, button: HTMLElement): void {
		button.classList.toggle('active', popover.isOpen());
	}

	getOperationExtraFeeOptional() {
		this.hasOperationOptionalExtraFee = this.blind.setup.operation.optional.some((option) => option.is_extra_fee);
	}
}
